// extracted by mini-css-extract-plugin
export var cartContainer = "_if-4";
export var gray = "_if-1";
export var itemContainer = "_if-2";
export var itemDetails = "_if-3";
export var strong = "_if-0";